import React, { useContext, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import Datetime from "react-datetime";
import moment from "moment";
import Select from 'react-select';

import CardBody from "beaktShared/components/Card/CardBody.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { ValidSelect } from "beaktShared/helpers/validselect";
import { MaskDate, formateDate, convertDate, validateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function RelatorioListaClientes({ open, closemodal }) {
    const { t } = useTranslation();
    const { handleSubmit } = useForm({ mode: "onChange" });
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
    const classes = useStyles();
    const [session, setSession] = React.useState(useContext(SessionContext));
    const [mensagemRetorno, setMensagemRetorno] = React.useState('');
    const [exibeMensagemRetorno, setExibeMensagemRetorno] = React.useState(false);
    const [emailUsuario, setEmailUsuario] = React.useState('');
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-1, 'months')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(false);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    
    useEffect(() => {
        if (open) {
            setMensagemRetorno('');
            setExibeMensagemRetorno(false);
            setEmailUsuario('');
            setSession(getSessionCookie());
            GetUsuario();
            LoadEstabelecimentos();
        }
    }, [open]);

    const GetUsuario = async () => {
        if (session?.id !== 0)
        {
            const endPoint = 'usuarios/' + session?.id;
            const result = await UseGetApiSimple(endPoint);
            if (result.status !== 200) {
                return;
            }
            else
            {
                setEmailUsuario(result?.data?.email);
            }
        }
    };

    const hideModal = () => {
        setMensagemRetorno('');
        setExibeMensagemRetorno(false);
        closemodal();
    };
    
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            setisLoadingEstabelecimento(false);
            setExibeMensagemRetorno(true);
            setMensagemRetorno(result.message);
            return;
        }

        setisLoadingEstabelecimento(false);
        setlistSelectEstabelecimentos(result.data);
        
        return true;
        });
    };

    const handleEstabelecimentoChange = event => {
        let value = event;
        let lstsAdd = [];
        let lstSelect = [];
        value.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });
        });
        setestabelecimentos(lstsAdd);
        setlistSelectEstabelecimentosSelected(lstSelect);
    };

    const handleClickSelecionarTodosEstabelecimentos = () => {
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });
        });
        setestabelecimentos(lstsAdd);
        setlistSelectEstabelecimentosSelected(lstSelect);
        
    };

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    };
    
    const onSubmit = async () => {
        setMensagemRetorno('');
        setExibeMensagemRetorno(false);
        
        if (session?.id !== 0)
        {
            var dataIniConvertida = '';
            var dataFimConvertida = '';

            if (session?.id > 1 && 
                listSelectEstabelecimentosSelected.length === 0) {
                setExibeMensagemRetorno(true);
                setMensagemRetorno('Selecione pelo menos um estabelecimento.');
                return;
            }

            let data = getValues();
            if(data.dtini === "")
            {
                setError("dtini","required", t('label.required'))
                return;
            }
            else
                clearError("dtini")
            
            if(data.dtfim === "")
            {
                setError("dtfim","required", t('label.required'))
                return;
            }
            else
                clearError("dtfim");
            
            if (!validateDate(data.dtini)) {
                setError("dtini", "invaliddate", t('error_message.invalid_date'))
                return;
            }
            else
                clearError("dtini");
            
            if (!validateDate(data.dtfim)) {
                setError("dtfim", "invaliddate", t('error_message.invalid_date'))
                return;
            }
            else
                clearError("dtfim");

            dataIniConvertida = convertDate(data.dtini);
            dataFimConvertida = convertDate(data.dtfim);

            if (session?.id > 1 && 
                monthDiff(dataIniConvertida,dataFimConvertida) > 1) {    
                setExibeMensagemRetorno(true);
                setMensagemRetorno(t('error_message.select_1month'));
                return; 
            }
            
            let obj = {
                estabelecimentos: listSelectEstabelecimentosSelected,
                usuarioId: session?.id,
                franquiaId: session?.franquiaId,
                dataIni: dataIniConvertida,
                dataFim: dataFimConvertida,
            }
            
            const endPoint = 'relatorios/relListaCliente/';
            
            try {
                const result = await UsePostApi(endPoint, obj);

                if (result.status !== 200) {
                    setExibeMensagemRetorno(true);
                    setMensagemRetorno('Erro na solicitação do relatório de lista de clientes.');
                    return;
                }
                
                if (result.data.sucesso === true) {
                    setExibeMensagemRetorno(true);
                    setMensagemRetorno(
                        <>
                            Arquivo <strong>{result.data.nomeArquivo}</strong> gerado com sucesso, 
                            em breve será enviado para seu e-mail.
                        </>
                    );
                }

                return;
            } catch (error) {
                setExibeMensagemRetorno(true);
                setMensagemRetorno('Erro na solicitação do relatório de lista de clientes.');
                return;
            }
        }
    };
    
    return (
        <>
            <CardBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>                
                            <FormControl fullWidth className={classes.formControl} style={{ marginBottom: '20px' }}>
                                <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>{t('label.establishment') + " *"} </label>
                                <Select
                                    menuPortalTarget={document.body}
                                    classNamePrefix="select"
                                    styles={{
                                      ...ValidSelect(errors.estabelecimentos ? true : false),
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    isMulti={true}
                                    isLoading={isLoadingEstabelecimento}
                                    name="estabelecimento"
                                    placeholder="Selecione..."
                                    options={listSelectEstabelecimentos}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                    value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}
                                    ref={() => register({ name: "estabelecimento" })}
                                />
                                {
                                  errors.estabelecimentos &&
                                  <FormHelperText>
                                      <span className="obg">{t('label.select_an_establishment')} </span>
                                  </FormHelperText>
                                }
                                <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                    <a href="#" onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{ marginTop: '10px' }}>
                                        {t('label.select_all_establishments')}
                                    </a>
                                </div>
                            </FormControl>
                          </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={6} md={4}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                    {t('label.ini_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtini"                                      
                                    defaultValue={dtini}
                                    value={dtini}
                                    onChange={date => { setdtini(date) }}
                                    inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtini?"error":""}            
                                />       
                                {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtini.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={4}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                    {t('label.end_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtfim"                                      
                                    defaultValue={dtfim}
                                    value={dtfim}
                                    onChange={date => { setdtfim(date) }}
                                    inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtfim?"error":""}            
                                />       
                                {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtfim.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                    
                    <div style={{ borderTop: '1px solid #C0C0C0', marginTop: '20px' }}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <h4>
                                Ao clicar em <strong>exportar</strong>, o arquivo será enviado para o e-mail{" "}
                                <strong>{emailUsuario}</strong>.
                            </h4>
                            <p>
                                <em>
                                    Caso o arquivo ultrapasse o limite do Excel, os dados serão divididos em mais de uma aba.
                                </em>
                            </p>
                        </GridItem>
                        {
                            exibeMensagemRetorno &&
                            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                                    <span style={{ fontStyle: 'italic' }}>
                                        {mensagemRetorno}
                                    </span>
                                </div>
                            </GridItem>
                        }
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <div className={classes.textCenter}>
                                <Button 
                                    onClick={() => hideModal()} 
                                    color="gray"
                                    className={classes.updateProfileButton}>
                                    {t('label.return')}
                                </Button>
                                <Button 
                                    type="submit" 
                                    color="primary" 
                                    className={classes.updateProfileButton}>
                                    {t('button.export')}
                                </Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                    </div>
                </form>
            </CardBody>
        </>
    );
}